import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication/authentication.service';

@Component({
  selector: 'ngx-root-redirector',
  templateUrl: './root-redirector.component.html',
  styleUrls: ['./root-redirector.component.scss']
})
export class RootRedirectorComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private auth: AuthenticationService,
  ) {
  }

  ngOnInit() {
    const vm = this;
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['token']) {
        window.location.href = 'auth/confirm?token=' + params['token'] + '&email=' + params['email'];
        // this.router.navigate([]);
      }
      else {
        vm.auth.isAuthenticated().then(authenticated => {
          if (authenticated) {
            this.router.navigate(['admin/']);
          } else {
            this.router.navigate(['auth/login']);
          }
        });
      }
    });
  }

}
